module.exports = __webpack_public_path__ + "static/img/zeta_cr_template_03.d45b1c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/zeta_cr_template_03.png
// module id = 4FD4
// module chunks = 1